import { FC, useState } from 'react';
import { TabMenu } from 'components/TabMenu';
import { useSelector } from 'react-redux';
import { RootState } from 'redux/store';
import { Payments } from './Payments';
import { Orders } from './Orders';
import { Taxes } from './Taxes';
import { HistoryTab } from './History';
import styles from './TabBeneficiaries.module.scss';
import { Documents } from './Documents';

export const TabEmployeds: FC = () => {
  const [active, setActive] = useState<string>('orders');
  const { listTabs, workerId } = useSelector((state: RootState) => state.mainInfo);

  const content: Record<string, React.ReactNode> = {
    payments: <Payments id={workerId} title={active} />,
    orders: <Orders id={workerId} title={active} />,
    taxes: <Taxes id={workerId} title={active} />,
    history: <HistoryTab id={workerId} title={active} />,
    documents: <Documents id={workerId} title={active} />,
  };

  return (
    <div className={styles.root}>
      <TabMenu
        cls={{ padding: 0 }}
        lists={listTabs}
        active={active}
        setActive={setActive}
      />
      {listTabs && workerId && <div className={styles.content}>{content[active]}</div>}
    </div>
  );
};
